import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';

export interface IPageProps {
	children: ReactNode;
	container?: boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'fluid';
	className?: string;
	/** Stable anchor for E2E and deep links. Already reached the DOM via the prop spread below;
	 *  it simply was not declared, so no caller could pass it. */
	id?: string;
}
const Page = forwardRef<HTMLDivElement, IPageProps>(
	({ children, className, container = 'xxl', ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={classNames('page', className, {
					[`container${typeof container === 'string' ? `-${container}` : ''}`]: container,
				})}
				{...props}>
				{children}
			</div>
		);
	},
);
Page.displayName = 'Page';

export default Page;
